import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomElementComponent } from './custom-element.component';

@NgModule({
	declarations: [
		CustomElementComponent
	],
	imports: [
		CommonModule
	],
	exports: [
		CustomElementComponent
	]
})
export class CustomFormModule { }